import { COUNTRIES_WITH_UNSUPPORTED_SUBDIVISIONS, PetriSpecs, UNSUPPORTED_SUBDIVISIONS_BY_COUNTRIES } from './constants';
function hasUnsupportedSubdivisions(countryKey) {
    return COUNTRIES_WITH_UNSUPPORTED_SUBDIVISIONS.includes(countryKey);
}
function shouldFilterUSMilitaryAddresses(countryKey, experiments) {
    return countryKey === 'USA' && !(experiments === null || experiments === void 0 ? void 0 : experiments.enabled(PetriSpecs.enableUnitedStatesMilitaryAddresses));
}
function getSubdivisionsToFilter(countryKey) {
    return UNSUPPORTED_SUBDIVISIONS_BY_COUNTRIES.find(function (x) { return x.countryKey === countryKey; }).subdivisionKeys;
}
function getFilteredSubdivisionList(country) {
    var subdivisionsToFilter = getSubdivisionsToFilter(country.key);
    return country.subdivisions.list.filter(function (x) { return !subdivisionsToFilter.includes(x.key); });
}
export function removeUnsupportedSubdivisions(countries, experiments) {
    countries.forEach(function (country) {
        if (hasUnsupportedSubdivisions(country.key) && shouldFilterUSMilitaryAddresses(country.key, experiments)) {
            country.subdivisions.list = getFilteredSubdivisionList(country);
        }
    });
}
export function isUnsupportedSubdivision(countryKey, stateKey, experiments) {
    if (!shouldFilterUSMilitaryAddresses(countryKey, experiments)) {
        return false;
    }
    var subdivisionsToFilter = getSubdivisionsToFilter(countryKey);
    return subdivisionsToFilter.includes(stateKey);
}
//# sourceMappingURL=unsupportedSubdivisionsRemover.js.map